import { Grid, Paper } from '@mui/material';
import { fields } from '@synergy/utils';
import { useField } from 'formik';

import { CustomerDetailOverviewFormValues } from '../models/customer-detail-overview-form-values';
import { PoolCategoryTree } from '../../../../../../common/components/pool-category-tree/pool-category-tree';

export const CustomerDetailOverviewCategories = () => {
    const fieldNames = fields<CustomerDetailOverviewFormValues>();
    const [field, _, helper] = useField<number[]>(fieldNames.categoryIds);

    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={12}>
                <Paper elevation={0}>
                    <PoolCategoryTree
                        selectedIds={field.value}
                        onChange={helper.setValue}
                        autoSelectParents={true}
                        searchable={true}
                    />
                </Paper>
            </Grid>
        </Grid>
    );
};
